import React from 'react'
import './Login.css'

import { Logo } from '../../../utils'
import LoginFunction from '../../../utils/CommonFunctionality/LoginFunction'
import Layout from '../Layout'
const LoginComponent = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <Layout props={props}>
            <div className="clearfix row vcaLogin">
                <div className="col-lg-3 d-none d-lg-block pad-0">
                    {/*<div className="loginImgBox d-flex justify-content-between flex-column"></div>*/}
                </div>
                <div className="col-lg-6 col-12">
                    <div className="loginFormBox">
                        {!isVarifiedGfTheme && <Logo className="m-auto" />}
                        <LoginFunction
                            title="Login"
                            subTitle="Welcome to Retail Rush"
                            after_login_redirect_path="home"
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default LoginComponent
